var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcUsdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26228 13.53C1.20928 21.6359 5.42017 30.7944 13.6312 33.7418C13.947 33.9525 14.2628 34.3734 14.2628 34.6893V36.1632C14.2628 36.3737 14.2628 36.479 14.1575 36.5841C14.0524 37.0053 13.6312 37.2157 13.2101 37.0053C7.31503 35.1104 2.78833 30.5837 0.893473 24.6887C-2.26463 14.6881 3.2095 4.05568 13.2101 0.897581C13.3154 0.79248 13.5259 0.79248 13.6312 0.79248C14.0524 0.897582 14.2628 1.21339 14.2628 1.63456V3.10825C14.2628 3.63477 14.0524 3.95058 13.6312 4.16104C9.31524 5.74009 5.84133 9.10864 4.26228 13.53ZM23.8425 1.31875C23.9476 0.897582 24.3688 0.687126 24.7899 0.897581C30.5796 2.79244 35.2117 7.31914 37.1065 13.3195C40.2646 23.3201 34.7905 33.9525 24.7899 37.1106C24.6846 37.2157 24.4741 37.2157 24.3688 37.2157C23.9476 37.1106 23.7371 36.7948 23.7371 36.3737V34.9C23.7371 34.3734 23.9476 34.0576 24.3688 33.8472C28.6848 32.2681 32.1587 28.8996 33.7377 24.4782C36.7907 16.3723 32.5798 7.21378 24.3688 4.26639C24.053 4.05568 23.7371 3.63477 23.7371 3.21361V1.73991C23.7371 1.5292 23.7371 1.4241 23.8425 1.31875ZM19.3159 17.2144C23.7373 17.7406 25.9479 19.0039 25.9479 22.6882C25.9479 25.5305 23.8426 27.7412 20.6845 28.2677V30.7942C20.5792 31.3205 20.2633 31.6363 19.8422 31.6363H18.2631C17.7369 31.5309 17.4211 31.2151 17.4211 30.7942V28.2677C13.9471 27.7412 12.2627 25.8463 11.8418 23.2148V23.1094C11.8418 22.6882 12.1576 22.3724 12.5786 22.3724H14.3683C14.6841 22.3724 14.9999 22.5831 15.105 23.004C15.4208 24.5831 16.3683 25.7412 19.1055 25.7412C21.1054 25.7412 22.5794 24.5833 22.5794 22.8989C22.5794 21.2145 21.6319 20.5829 18.6843 20.0567C14.263 19.5301 12.1576 18.1618 12.1576 14.6879C12.1576 12.056 14.1576 9.95073 17.3157 9.52957V7.10844C17.4211 6.58192 17.7369 6.26611 18.158 6.26611H19.7371C20.2634 6.37147 20.5792 6.68728 20.5792 7.10844V9.63492C23.0003 9.84538 24.8951 11.6349 25.3163 13.9509V14.0563C25.3163 14.4772 25.0005 14.793 24.5793 14.793H22.8952C22.5794 14.793 22.2636 14.5825 22.1582 14.2667C21.6319 12.6877 20.5792 12.056 18.6843 12.056C16.579 12.056 15.5262 13.0032 15.5262 14.4772C15.5262 15.9511 16.1578 16.7932 19.3159 17.2144Z",
    fill: "url(#paint0_linear_4596_14711)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4596_14711",
    x1: 19,
    y1: 0.79248,
    x2: 19,
    y2: 37.2157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74B6FF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUsdc);
export default __webpack_public_path__ + "static/media/ic_usdc.49bac9a1edd3855aa02b71caa5f2c893.svg";
export { ForwardRef as ReactComponent };